import React from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import WorkIcon from "@mui/icons-material/Work";
import Skeleton from "@mui/material/Skeleton";

const CardShimmer = () => {
  return (
    <div className="openPositionCardMain">
      <div className="openPositionCardText-m1">
        <Skeleton animation="wave" />
      </div>
      <div className="openPositionCardText-m2">
        <Skeleton animation="wave" />
      </div>
      <div className="openPositionCardText-m3">
        <div>
          <LocationOnIcon />
        </div>
        <div className="openPositionCardText-m3-text">
          <Skeleton animation="wave" />
        </div>
      </div>
      <div className="openPositionCardText-m3">
        <div>
          <WorkIcon />
        </div>
        <div className="openPositionCardText-m3-text">
          <Skeleton animation="wave" />
        </div>
      </div>
    </div>
  );
};

export default CardShimmer;
